export default __webpack_public_path__ + "0342b0ab023a7ce420ed8185cee97124.svg";